module.exports = __webpack_public_path__ + "static/media/vehicleTourismWhite.aea4d221.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/vehicleTourismWhite.svg
 ** module id = 1298
 ** module chunks = 0
 **/